import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-finance-overview',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
  ],
  templateUrl: './finance-overview.component.html',
  styleUrl: './finance-overview.component.scss',
})
export class FinanceOverviewComponent {
  pageSizeOption = [5, 10, 20, 50, 100];

  counter = {
    allCount: 0,
    receivedCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    unclosedCount: 0,
    closedCount: 0,
  };

  displayedColumns = ['no', 'staff', 'team', 'refId', 'title', 'amount', 'action'];
  dataSource = new MatTableDataSource<any>([]);
  dataTotal = 0;
  page = 1;
  limit = 20;
  searchControl = new FormControl();

  constructor(private router: Router) {}

  onPageChange(event: PageEvent): void {
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;
  }

  parseNo(index: number): number {
    return (this.page - 1) * this.limit + index + 1;
  }

  getStaffName(element: any): string {
    const first = element.creator?.firstName ?? '';
    const last = element.creator?.lastName ?? '';
    return `${first} ${last}`.trim() || '-';
  }

  detail(id: any): void {
    this.router.navigate(['/dashboard/cash-advance-finance/action'], {
      queryParams: { m: 'detail', id },
    });
  }
}
